import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from "./App";
import "./index.css";
import { initGA } from "./utils/analytics";
import { initWebVitals, trackPageLoadTime, trackResourceTiming } from "./utils/webVitals";

// Initialize Google Analytics
initGA();

// Initialize Web Vitals tracking
initWebVitals();
trackPageLoadTime();
trackResourceTiming();

// React 18+ root API with pre-rendering support
const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // If HTML is pre-rendered (by react-snap), hydrate instead of render
  hydrateRoot(
    rootElement,
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
} else {
  // Normal render for development or non-pre-rendered builds
  createRoot(rootElement).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}